'use client';

import { GlowTypography, PropsWithFontFamily, PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { StringHelpers } from '@headless-workspace/utils';
import { PromotionType } from '../../../../../server';
import { ProductDetailPricesContainerVariant } from './ProductDetailPricesContainer';

type ProductDetailPriceProps = PropsWithFontFamily &
    PropsWithLocale & {
        currency: string;
        price?: number;
        pricePerUnit?: string;
        promotion?: PromotionType;
        priceAlwaysBlack: boolean;
        displayLegalMentionInformation: boolean;
        variant?: ProductDetailPricesContainerVariant;
        isPriceLegalMentionEnabled: boolean;
    };
const PRODUCT_DETAIL_PRICE_ID = 'product-detail-price';
const FIRST_SUP_INDEX = '(1)';

export const ProductDetailPrice: Component<ProductDetailPriceProps> = ({
    price,
    locale,
    currency,
    pricePerUnit,
    fontFamily,
    promotion,
    priceAlwaysBlack,
    displayLegalMentionInformation,
    variant = 'default',
    isPriceLegalMentionEnabled,
}) => {
    const promotionColor =
        priceAlwaysBlack || !promotion || [PromotionType.REGULAR, PromotionType.OMNIBUS_POSITIVE].includes(promotion)
            ? 'primary'
            : 'promotion';

    return (
        <div id={PRODUCT_DETAIL_PRICE_ID}>
            <div className={'flex flex-row gap-0.25'}>
                <GlowTypography
                    text={StringHelpers.formatPriceWithConditions(price, currency, locale, isPriceLegalMentionEnabled)}
                    fontFamily={fontFamily}
                    fontWeight={'bold'}
                    fontSize={variant === 'default' ? 'title3' : 'body'}
                    color={promotionColor}
                />
                {displayLegalMentionInformation && (
                    <GlowTypography
                        text={FIRST_SUP_INDEX}
                        TagName={'sup'}
                        fontWeight={'bold'}
                        fontSize={variant === 'default' ? 'bodySmall' : 'caption'}
                    />
                )}
            </div>
            {pricePerUnit && (
                <GlowTypography
                    color={'secondary'}
                    text={pricePerUnit}
                    fontFamily={fontFamily}
                    fontSize={variant === 'default' ? 'bodySmall' : 'caption'}
                />
            )}
        </div>
    );
};
